<main class="em-l-container main-content">
  <h4>List of Suppliers</h4>

  <div *ngIf="loading">
    <app-loader></app-loader>
  </div>

  <div *ngIf="!loading">
    <div class="em-l-grid em-l-grid--2up">
      <div class="em-l-grid__item"></div>
      <div class="em-l-grid__item">
        <div class="menubar-container">
          <!-- Search bar -->
          <div
            class="em-c-search-form em-js-header-search menubar-container__searchbar"
          >
            <label for="search" class="em-c-search__label em-u-is-vishidden"
              >Search</label
            >
            <div class="em-c-field em-is-readonly">
              <div class="em-c-field__body">
                <input
                  class="em-c-input em-js-input"
                  placeholder="search"
                  [(ngModel)]="searchString"
                />
                <svg
                  class="em-c-icon em-c-icon--medium em-c-field__icon em-u-clickable"
                  (click)="clearSearch()"
                >
                  <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="assets/unity-1.6.0/images/24/em-icons.svg#circle-x"
                  ></use>
                </svg>
              </div>
            </div>
          </div>
          <!-- New button -->
          <button
            class="em-c-btn em-c-btn--primary menubar-container__newbutton"
            [routerLink]="['/supplier-profile/create-supplier-profile']"
            *ngIf="(storeService.user$ | async)?.canMaintainSupplierProfile"
          >
            <div class="em-c-btn__inner">
              <svg
                class="em-c-icon em-c-icon--small em-c-btn__icon"
                data-em-icon-path="assets/unity-1.6.0/images/em-icons.svg"
              >
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="assets/unity-1.6.0/images/em-icons.svg#circle-plus"
                ></use>
              </svg>
              <span class="em-c-btn__text">New</span>
            </div>
          </button>
        </div>
      </div>
    </div>

    <div class="em-c-table-object">
      <div class="em-c-table-object__header"></div>
      <div class="em-c-table-object__body" *ngIf="!loading">
        <div class="em-c-table-object__body-inner">
          <table class="em-c-table">
            <!-- Table Header -->
            <thead class="em-c-table__header">
              <tr class="em-c-table__header-row">
                <th scope="col" class="em-c-table__header-cell">
                  Supplier Identity
                </th>
                <th scope="col" class="em-c-table__header-cell">
                  Supplier Name
                </th>
              </tr>
            </thead>
            <!-- Table Body -->
            <tbody class="em-c-table__body">
              <tr
                class="em-c-table__row em-u-clickable"
                [routerLink]="[supplier.supplierIdentity]"
                *ngFor="
                  let supplier of storeService.supplierList$
                    | async
                    | supplierFilter: searchString
                "
              >
                <td class="em-c-table__cell em-js-cell" colspan="">
                  <a [routerLink]="[supplier.supplierIdentity]">{{
                    supplier.supplierIdentity
                  }}</a>
                </td>
                <td class="em-c-table__cell em-js-cell" colspan="">
                  {{ supplier.supplierName }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="em-c-toolbar">
        <div class="em-c-toolbar__item">
          Total {{ (storeService.supplierList$ | async)?.length }} Supplier
          Profiles
        </div>
      </div>
    </div>
  </div>
</main>
